// select newid()
const actionTypeIdentifier = "B257C330-5BEF-467C-BCA7-E1C4A7C1F494";

export const setCircuitHistoryLogsLoading = `SET-CIRCUIT-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getCircuitHistoryLogs = `GET-CIRCUIT-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setCircuitHistoryPageSize = `SET-CIRCUIT-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetCircuitHistory = `RESET-CIRCUIT-HISTORY-${actionTypeIdentifier}`;
export const setCircuitHistoryColSearchStr = `SET-CIRCUIT-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;